// extracted by css-extract-rspack-plugin
export default {"root":"NjGABA","cards":"vQQKz_","card":"_dWhJM","header":"PCRJww","iconBox":"noVhk_"};